import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { states } from '../../share/states';

@Component({
    selector: 'app-state-select',
    templateUrl: './state-select.component.html',
    styleUrls: ['./state-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: StateSelectComponent
        }
    ],
    standalone: false
})
export class StateSelectComponent implements ControlValueAccessor {
  @Input() required: boolean;
  @Input() default: boolean;
  states: any = states;
  touched: boolean = false;
  disabled: boolean = false;
  selectedState: string = "";
  onChange = (value) => {};
  onTouched = (event) => {};

  constructor() { }

  writeValue(obj: string): void {
    this.selectedState = obj;
  }

  changeState(event): void {
    this.checkAndSetClass(event);
    this.markAsTouched(event);
    if (!this.disabled) {
      this.onChange(this.selectedState);
    }
  }

  markAsTouched(event): void {
    if (!this.touched) {
      this.onTouched(event);
      this.touched = true;
    }
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  checkAndSetClass(e) {
    let type = e.type;
    let target = e.target;
    let value = target.value;
    let parentElement = target.parentElement.parentElement;
    if (value || type === 'focus') {
      parentElement.classList.add('inputted');
    } else {
      parentElement.classList.remove('inputted');
    }
    if (type === 'blur') {
      this.onTouched(e);
    }
  }

}
